import {
  Box,
  Card,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/free-mode';

import FlexBox from 'components/flexbox/FlexBox';
import KakaoLoginModal from 'components/modal/kakaoLoginModal';
import { ArrowLeft } from 'lucide-react';
import Footer from 'page-sections/callmetellme/Footer';
import MenuBox from 'page-sections/callmetellme/MenuBox';
import ProfileStatsCard from 'page-sections/callmetellme/ProfileStatsCard';
import CategoryBox from '../../../page-sections/callmetellme/CategoryBox';
import CommunityDetailSection from '../../../page-sections/callmetellme/community/CommunityDetailSection';

const profileMenuData = [
  {
    text: 'AI 추천 지원사업',
    count: 0,
    path: '/naver/callmetellme/mypage/ai-recommended-support-programs',
  },
  {
    text: 'AI 추천 정책자금',
    count: 0,
    path: '/naver/callmetellme/mypage/ai-recommended-policy-funds',
  },
  {
    text: '북마크한 지원사업',
    count: 3,
    path: '/naver/callmetellme/mypage/bookmarked-support-programs',
  },
  {
    text: '북마크한 게시글',
    count: 57,
    path: '/naver/callmetellme/mypage/bookmarked-posts',
  },
  {
    text: '내가 쓴 게시글',
    count: 90,
    path: '/naver/callmetellme/mypage/my-posts',
  },
  {
    text: '내가 쓴 댓글',
    count: 100,
    path: '/naver/callmetellme/mypage/my-comments',
  },
  {
    text: '내 댓글에 답글',
    count: 1001,
    path: '/naver/callmetellme/mypage/replies-to-my-comments',
  },
  {
    text: '내 게시글에 달린 댓글',
    count: 57,
    path: '/naver/callmetellme/mypage/comments-on-my-posts',
  },
];

const fundingData = [
  {
    id: 1,
    title: '2025년 여성창업 상세세이지 교육 및 컨설팅',
    category: 'AI 한줄 요약',
    amount: '9,500만원',
    deadline: '25.01.06',
    tags: ['지원금', '소상공인', '고용안정'],
    description:
      '신산업 책임보험 최대 700만원/년 내 지원이 제공됩니다.\n해외 전시회 참여 1건에 대해 최대 500만원 지원이 제공됩니다.',
    logo: '/static/logo/SMEs.png',
  },
  {
    id: 2,
    title: '2025년 여성창업 상세세이지 교육 및 컨설팅',
    category: 'AI 한줄 요약',
    amount: '9,500만원',
    deadline: '25.01.06',
    tags: ['지원금', '소상공인', '고용안정'],
    description:
      '신산업 책임보험 최대 700만원/년 내 지원이 제공됩니다.\n해외 전시회 참여 1건에 대해 최대 500만원 지원이 제공됩니다.',
    logo: '/static/logo/SMEs.png',
  },
  {
    id: 3,
    title: '2025년 여성창업 상세세이지 교육 및 컨설팅',
    category: 'AI 한줄 요약',
    amount: '9,500만원',
    deadline: '25.01.06',
    tags: ['지원금', '소상공인', '고용안정'],
    description:
      '신산업 책임보험 최대 700만원/년 내 지원이 제공됩니다.\n해외 전시회 참여 1건에 대해 최대 500만원 지원이 제공됩니다.',
    logo: '/static/logo/SMEs.png',
  },
  {
    id: 4,
    title: '2025년 여성창업 상세세이지 교육 및 컨설팅',
    category: 'AI 한줄 요약',
    amount: '9,500만원',
    deadline: '25.01.06',
    tags: ['지원금', '소상공인', '고용안정'],
    description:
      '신산업 책임보험 최대 700만원/년 내 지원이 제공됩니다.\n해외 전시회 참여 1건에 대해 최대 500만원 지원이 제공됩니다.',
    logo: '/static/logo/SMEs.png',
  },
  {
    id: 4,
    title: '2025년 여성창업 상세세이지 교육 및 컨설팅',
    category: 'AI 한줄 요약',
    amount: '9,500만원',
    deadline: '25.01.06',
    tags: ['지원금', '소상공인', '고용안정'],
    description:
      '신산업 책임보험 최대 700만원/년 내 지원이 제공됩니다.\n해외 전시회 참여 1건에 대해 최대 500만원 지원이 제공됩니다.',
    logo: '/static/logo/SMEs.png',
  },
];

export default function CommunityDetail() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  const [showKaKaoLoginModal, setShowKaKaoLoginModal] = useState(false);

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    padding: 0,
    backgroundColor: isMobile
      ? theme.palette.primary.white
      : theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: 'none',
  }));

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.lightGrey200,
      }}
    >
      <KakaoLoginModal
        showModal={showKaKaoLoginModal}
        setShowModal={setShowKaKaoLoginModal}
      />

      {isMobile && (
        <Box
          position="fixed"
          pl={isMobile ? 2 : 0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            bottom: '70px',
            zIndex: 1000,
          }}
        >
          <FlexBox
            onClick={() => navigate(-1)}
            sx={{
              border: '1px solid #E1E1E1',
              cursor: 'pointer',
              backgroundColor: 'white',
              padding: '4px',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
            }}
          >
            <ArrowLeft size={30} color={theme.palette.primary.greytxt} />
          </FlexBox>
        </Box>
      )}
      {/* {isMobile && <CallmeTellmeBottomBar />} */}

      <Grid
        container
        xs={12}
        gap={2}
        paddingX={!isDesktop ? '0px' : '120px'}
        justifyContent={'center'}
      >
        {!isTablet && (
          <Grid
            item
            xs={12}
            lg={1.5}
            sx={{
              position: 'sticky',
              top: '76px',
              alignSelf: 'flex-start',
              height: 'fit-content',
              width: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                padding: isTablet ? '15px 0px 0px 0px' : '20px 0px 20px 0px',
                backgroundColor: theme.palette.primary.lightGrey200,
                borderRadius: 0,
                border: 'none',
                [theme.breakpoints.down('sm')]: {
                  '& > .MuiBox-root': {
                    paddingBottom: 0,
                  },
                },
              }}
            >
              <FlexBox gap={2} flexDirection={'column'}>
                <CategoryBox />
              </FlexBox>
            </Box>
          </Grid>
        )}

        <Grid item xs={12} lg={7.5} mt={isMobile ? 1 : 0}>
          {isMobile && (
            <Box
              pl={isMobile ? 2 : 0}
              sx={{ marginBottom: 2, display: 'flex', alignItems: 'center' }}
            >
              <FlexBox
                onClick={() => navigate(-1)}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: 'white',
                  padding: '4px',
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
                }}
              >
                <ArrowLeft size={30} color={theme.palette.primary.greytxt} />
              </FlexBox>
            </Box>
          )}

          <StyledCard
            sx={{
              border: 'none',
              paddingBottom: isMobile ? '0px' : '30px',
            }}
          >
            <Grid
              container
              sx={{ width: '100%', paddingTop: isMobile ? '0px' : '30px' }}
              mb={3}
            >
              <CommunityDetailSection
                isTablet={isTablet}
                isMobile={isMobile}
                fundingData={fundingData}
              />
            </Grid>
          </StyledCard>
        </Grid>

        {!isTablet && (
          <Grid
            item
            xs={12}
            lg={2.5}
            sx={{
              position: 'sticky',
              top: '76px',
              alignSelf: 'flex-start',
              height: 'fit-content',
            }}
          >
            <Box
              sx={{
                width: '100%',
                padding: isTablet ? '15px 0px 0px 0px' : '20px 0px 0px 0px',
                backgroundColor: theme.palette.primary.lightGrey200,
                borderRadius: 0,
                border: 'none',
                [theme.breakpoints.down('sm')]: {
                  '& > .MuiBox-root': {
                    paddingBottom: 0,
                  },
                },
              }}
            >
              <FlexBox gap={2} flexDirection={'column'}>
                <ProfileStatsCard data={profileMenuData} />
                <MenuBox />
              </FlexBox>
            </Box>
          </Grid>
        )}
      </Grid>

      <Box paddingBottom={isMobile ? '60px' : '0px'} backgroundColor="#EAEAEA">
        <Footer />
      </Box>
    </Box>
  );
}
